<!-- Start Content-->
<div class="container-fluid">
  <div class="row my-1">
    <div class="col-md-12">
      <div class="userTables">
        <h2 *ngIf="!isModal">change password</h2>
        <form class="new-cp-form" [formGroup]="formData" (ngSubmit)="onSubmit()">
          <div class="row">
            <div [ngClass]="isModal ? 'col-md-12' : 'col-md-6'">
              <div class="form-group">
                <label class="text-capitalize font-weight-bold mb-0" for="">old password</label>
                <input [type]="oldPasswordTextType ? 'text' : 'password'" class="form-control"                        formControlName="old_password"
                       [ngClass]="{ 'is-invalid': submitted && f.old_password.errors }">
                <div *ngIf="submitted && f.old_password.errors" class="invalid-feedback">
                  <div *ngIf="f.old_password.errors.required">The Old Password field is required</div>
                </div>
                <!--                      <a class="eye-off-on"><i class="mdi mdi-eye"></i></a>-->
                <a class="eye-off-on" (click)="toggleOldPasswordFieldTextType()"><i class="mdi" [ngClass]="{
          'mdi-eye': !oldPasswordTextType,
          'mdi-eye-off': oldPasswordTextType
        }"></i></a>
              </div>
              <div class="form-group">
                <label class="text-capitalize font-weight-bold mb-0" for="">new password</label>
                <input [type]="newPasswordTextType ? 'text' : 'password'" class="form-control"
                       formControlName="new_password"
                       [ngClass]="{ 'is-invalid': submitted && f.new_password.errors }">
                <div *ngIf="submitted && f.new_password.errors" class="invalid-feedback">
                  <div *ngIf="f.new_password.errors.required">The New Password field is required</div>
                  <div *ngIf="f.new_password.errors.minlength">The New Password field must be at least 6 characters
                  </div>
                  <div *ngIf="!f.new_password.errors.minlength && f.new_password.errors.pattern">The New Password must
                    contain at least: 1 uppercase letter, 1 lowercase letter, 1 number
                  </div>
                </div>
                <a class="eye-off-on" (click)="toggleNewPasswordFieldTextType()"><i class="mdi" [ngClass]="{
          'mdi-eye': !newPasswordTextType,
          'mdi-eye-off': newPasswordTextType
        }"></i></a>
              </div>
              <div class="form-group">
                <label class="text-capitalize font-weight-bold mb-0" for="">confirm password</label>
                <input [type]="confirmPasswordTextType ? 'text' : 'password'" class="form-control"
                       formControlName="new_password_re"
                       [ngClass]="{ 'is-invalid': submitted && f.new_password_re.errors }">
                <div *ngIf="submitted && f.new_password_re.errors" class="invalid-feedback">
                  <div *ngIf="f.new_password_re.errors.required">The Confirm Password field is required</div>
                  <div *ngIf="f.new_password_re.errors.mustMatch">The Confirm Password confirmation does not match
                  </div>
                </div>
                <a class="eye-off-on" (click)="toggleConfirmPasswordFieldTextType()"><i class="mdi" [ngClass]="{
          'mdi-eye': !confirmPasswordTextType,
          'mdi-eye-off': confirmPasswordTextType
        }"></i></a>
              </div>
              <div class="form-group mt-2">
                <button type="submit" class="btn cp-btn">change password</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
